/**
 * Frequency stays a hard-coded list — it is a closed set, unlike form types,
 * which are now tenant-editable data served by /api/form-type.
 *
 * This module exists because the same array had been copy-pasted into
 * FormFrequencyDropdown, AllForms, TemplateList and CustomerFormsMockup, and
 * the search work needed one more copy.
 */
export const FREQUENCIES = [
  { value: 0, label: "One Time" },
  { value: 1, label: "Weekly" },
  { value: 2, label: "Monthly" },
  { value: 3, label: "Quarterly" },
  { value: 4, label: "Semi-Annual" },
  { value: 5, label: "Annual" },
];

export const FREQUENCY_ONE_TIME = 0;

export const getFrequencyLabel = (value) =>
  FREQUENCIES.find((f) => f.value === Number(value))?.label || "-";

/**
 * Which frequency values a search keyword names, as a comma-separated list for
 * the `frequencyMatches` query param.
 *
 * The server can search form *types* by name because they are a table it can
 * join. Frequencies are not, so the client resolves the keyword here and the
 * server ORs the resulting values into the same search. Returns undefined when
 * the keyword names no frequency, which leaves the param off entirely.
 */
export const matchFrequencies = (keyword) => {
  const term = (keyword || "").trim().toLowerCase();
  if (!term) return undefined;
  const matches = FREQUENCIES.filter((f) => f.label.toLowerCase().includes(term)).map((f) => f.value);
  return matches.length ? matches.join(",") : undefined;
};

/**
 * A row's form type name. Prefers the joined `formTypeRef` the API now returns;
 * falls back to the stored id so a row whose type was retired still shows
 * something rather than a blank cell.
 */
export const getFormTypeLabel = (row) => {
  if (row?.formTypeRef?.name) return row.formTypeRef.name;
  return row?.formType !== undefined && row?.formType !== null ? `Type ${row.formType}` : "-";
};
